import React from "react";
import "./TableContainer.css";

const TableContainer = ({ className = "", children }) => {
  const mergedClassName = ["table-container", className].filter(Boolean).join(" ");
  return <div className={mergedClassName}>{children}</div>;
};

export default TableContainer;
